import ThreeDotLoader from '@shared/components/ThreeDotLoader';
import { useAuth } from '@features/auth/contexts/AuthContext';
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useEffect } from "react";

export const AdminRouteGuard = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  // Store the attempted URL for redirect after login
  const from = location.pathname + location.search;

  useEffect(() => {
    if (!auth.isLoading && auth.user && auth.user.role !== "admin") {
      toast.error(
        t(
          "auth.insufficientPermissions",
          "You don't have permission to access this page."
        )
      );
    }
  }, [auth.isLoading, auth.user, t]);

  if (auth.isLoading) {
    return (
      <div className="min-h-svh flex items-center justify-center">
        <p>check status</p>
        <ThreeDotLoader />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!auth.user) {
    return <Navigate to="/login" state={{ from }} replace />;
  }

  // Redirect to home if not admin
  if (auth.user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export const DeliveryPersonRouteGuard = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  // Store the attempted URL for redirect after login
  const from = location.pathname + location.search;

  useEffect(() => {
    if (!auth.isLoading && auth.user && auth.user.role !== "livreur") {
      toast.error(
        t(
          "auth.insufficientPermissions",
          "You don't have permission to access this page."
        )
      );
    }
  }, [auth.isLoading, auth.user, t]);

  if (auth.isLoading) {
    return (
      <div className="min-h-svh flex items-center justify-center">
        <p>check status</p>
        <ThreeDotLoader />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!auth.user) {
    return <Navigate to="/login" state={{ from }} replace />;
  }

  // Redirect to home if not delivery person
  if (auth.user.role !== "livreur") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export const AdminOrDeliveryPersonRouteGuard = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  // Store the attempted URL for redirect after login
  const from = location.pathname + location.search;

  useEffect(() => {
    if (
      !auth.isLoading &&
      auth.user &&
      auth.user.role !== "admin" &&
      auth.user.role !== "livreur"
    ) {
      toast.error(
        t(
          "auth.insufficientPermissions",
          "You don't have permission to access this page."
        )
      );
    }
  }, [auth.isLoading, auth.user, t]);

  if (auth.isLoading) {
    return (
      <div className="min-h-svh flex items-center justify-center">
        <p>check status</p>
        <ThreeDotLoader />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!auth.user) {
    return <Navigate to="/login" state={{ from }} replace />;
  }

  // Redirect to home if not admin or delivery person
  if (auth.user.role !== "admin" && auth.user.role !== "livreur") {
    return <Navigate to="/" replace />;
  }

  return children;
};
